import { resolveProductModelNo, resolveProductName } from '~/utils/tracking/helpers'

/**
 * @description 商城侧商品展示名：「产品型号 + 空格 + 商品名称」；对齐后端接口字段 modelNo / productModelNo / prodModel。
 * @param {Record<string, unknown>} source - 订单行、购物车行、赠品等
 * @returns {string}
 */
export function formatStoreProductDisplayName(source = {}) {
  if (source == null || typeof source !== 'object') return ''
  const model = pickProductModelNo(source)
  const name = resolveProductName(source)
  if (model && name) return `${model} ${name}`
  if (model) return model
  return name
}

/**
 * @description 从业务对象上解析产品型号字符串（去首尾空格）
 * @param {Record<string, unknown>} source
 * @returns {string}
 */
export function pickProductModelNo(source = {}) {
  return resolveProductModelNo(source)
}
